import { APP_STORAGE_PREFIX } from "./appStorage";

const KEY = `${APP_STORAGE_PREFIX}notification_reads_v1`;

function loadReadIds() {
  if (typeof window === "undefined") return new Set();
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return new Set();
    const parsed = JSON.parse(raw);
    return new Set(Array.isArray(parsed) ? parsed : []);
  } catch {
    return new Set();
  }
}

function saveReadIds(ids) {
  if (typeof window === "undefined") return;
  localStorage.setItem(KEY, JSON.stringify([...ids]));
}

export function isNotificationRead(item) {
  if (!item?.id) return false;
  if (item.read_at) return true;
  return loadReadIds().has(item.id);
}

export function markNotificationReadLocal(id) {
  if (!id) return;
  const ids = loadReadIds();
  ids.add(id);
  saveReadIds(ids);
}

export function markAllNotificationsReadLocal(ids) {
  const set = loadReadIds();
  for (const id of ids) {
    if (id) set.add(id);
  }
  saveReadIds(set);
}

export function getUnreadNotifications(notifications) {
  return (notifications || []).filter((n) => n?.id && !isNotificationRead(n));
}

export { isNotificationRead as isBroadcastRead, markNotificationReadLocal as markBroadcastRead, markAllNotificationsReadLocal as markAllBroadcastsRead, getUnreadNotifications as getUnreadBroadcasts };
